import { useInfiniteQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from '@/config/constants'
import { fetchClaimsPage } from '@/features/claims/api/api'
import { requireAuthToken, type ListQueryParams } from '@/lib/api'
import { claimsKeys } from '@/lib/queryKeys'

export function useClaimsQuery(params: ListQueryParams) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useInfiniteQuery({
    queryKey: claimsKeys.list(organization?.id, params),
    enabled: Boolean(organization?.id),
    queryFn: async ({ pageParam, signal }) => {
      const token = await requireAuthToken(getToken)
      return fetchClaimsPage({
        token,
        params,
        cursor: pageParam,
        signal,
      })
    },
    getNextPageParam: (lastPage) =>
      lastPage.pagination.next_cursor ?? undefined,
    initialPageParam: undefined as string | undefined,
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
    refetchOnWindowFocus: false,
  })
}
